import { z } from 'zod';

export const tipoHoraInputSchema = z.object({
  nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  sigla: z.string().trim().min(1, 'Obrigatório').max(10, 'Máximo 10 caracteres'),
  multiplicadorHora: z
    .number()
    .min(0, 'Mínimo 0')
    .refine(Number.isFinite, { message: 'Número inválido' }),
  tipo: z.enum(['PAD', 'ADI', 'PLA', 'ACI']),
  ativo: z.boolean().optional(),
});

export type TipoHoraFormValues = z.infer<typeof tipoHoraInputSchema>;
